document.addEventListener("DOMContentLoaded", () => {
  const localStorageKey = "bookmarks";

  const bookmarks = document.querySelectorAll(".js-bookmark");

  const getCurrentBookmarks = () => {
    const currentLocalStorage = localStorage.getItem(localStorageKey)
      ? localStorage.getItem(localStorageKey).split(",")
      : [];
    return currentLocalStorage;
  };

  bookmarks.forEach((bookmark) => {
    const isBookmarked = getCurrentBookmarks().includes(
      bookmark.dataset.productid
    );
    if (isBookmarked) {
      bookmark.classList.add("active");
    }
    bookmark.addEventListener("click", () => {
      if (bookmark.classList.contains("active")) {
        localStorage.setItem(
          localStorageKey,
          getCurrentBookmarks()
            .filter((item) => item !== bookmark.dataset.productid)
            .join(",")
        );
      } else {
        localStorage.setItem(
          localStorageKey,
          [...getCurrentBookmarks(), bookmark.dataset.productid].join(",")
        );
      }

      window.dispatchEvent(new Event("bookmarksChanged"));
      bookmark.classList.toggle("active");
    });
  });
});
